module.exports = __webpack_public_path__ + "img/cekkmp.858429ce.svg";